import { render, staticRenderFns } from "./ElementsText.vue?vue&type=template&id=7a848131&"
import script from "./ElementsText.vue?vue&type=script&lang=js&"
export * from "./ElementsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports